import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryLastUsedReport'
import Component from 'components/Reports/InventoryLastUsedReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryLastUsedReport })(Component)
